import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeopleColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M32 21C32 27.6274 26.6274 33 20 33C13.3726 33 8 27.6274 8 21C8 14.3726 13.3726 9 20 9C26.6274 9 32 14.3726 32 21ZM11.5117 21C11.5117 25.688 15.312 29.4883 20 29.4883C24.688 29.4883 28.4883 25.688 28.4883 21C28.4883 16.312 24.688 12.5117 20 12.5117C15.312 12.5117 11.5117 16.312 11.5117 21Z",
			fill: "#6269EE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32 21C32 27.6274 26.6274 33 20 33C13.3726 33 8 27.6274 8 21C8 14.3726 13.3726 9 20 9C26.6274 9 32 14.3726 32 21ZM9.46892 21C9.46892 26.8162 14.1838 31.5311 20 31.5311C25.8162 31.5311 30.5311 26.8162 30.5311 21C30.5311 15.1838 25.8162 10.4689 20 10.4689C14.1838 10.4689 9.46892 15.1838 9.46892 21Z",
			fill: "url(#paint0_angular_320_31597)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 10.5,
			r: 2.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 29.5,
			cy: 25.5,
			r: 2.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.5,
			cy: 25.5,
			r: 2.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_angular_320_31597",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(20 21) rotate(-33.6901) scale(11.8)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .00183952,
					stopColor: "#51B7D8"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .368179,
					stopColor: "#656CFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .645971,
					stopColor: "#AC8EFF"
				})
			]
		}) })
	]
});
export default SvgPeopleColored;
